import React, { useState, useEffect,useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useUsuario from "../../../hooks/useUsuario";
import * as Iconsax from "iconsax-react";
import ToastEva from "../../../components/Toast/ToastEva";
import { ObtenerCapacitacionObligatoriaPreguntasPorId ,RegistrarRespuestasUsuario} from "../../../service/CapacitacionService";
import "./CapaObligatoria.scss"
import { Steps } from "rsuite";
import Boton from "../../../components/Boton/Boton";
import { ListBox } from "primereact/listbox";
import { Dialog } from "primereact/dialog";

const PreguntasCapaObligatoria = () => {
const [step, setStep] = useState(0);

const navigate = useNavigate();
    const {isLogged} = useUsuario()
    const [capaObligatoria, setCapaObligatoria] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [errorCarga, setErrorCarga] = useState(null);
    const [intentoCarga, setIntentoCarga] = useState(0);
    const [enviando, setEnviando] = useState(false);
    const toast = useRef(null);
    const { idSeccion, idCapacitacion, visualizacion } = useParams();
    
     
    const [mostrarDialog, setMostrarDialog] = useState(false);
    const [respuestSecleccionada, setRespuestSecleccionada] = useState([]);

    const [tituloDialog, setTituloDialog] = useState("");
    const [estadoRespuesta, setEstadoRespuesta] = useState("");
    const [resultadoUsuario, setResultadoUsuario] = useState(null);
    const preguntas = capaObligatoria?.capacitacion_obligatoria_preguntas || [];
    const numeroPreguntas = preguntas.length;
    const preguntaActual = preguntas[step];
    const respuestaActual = respuestSecleccionada.find(item => item.idPregunta === preguntaActual?.id);
    const mostrarBotonEnviar = !visualizacion;
    useEffect(()=>{
        !isLogged && navigate("/");
    },[isLogged, navigate])

    useEffect(()=>{
        let activo = true;
        const getCapacitacion = async () => {
            setCargando(true);
            setErrorCarga(null);
            try {
                const jwt = window.localStorage.getItem("jwt");
                const data = await ObtenerCapacitacionObligatoriaPreguntasPorId({jwt, Id: idCapacitacion});
                const preguntas = Array.isArray(data?.capacitacion_obligatoria_preguntas)
                    ? data.capacitacion_obligatoria_preguntas
                    : [];

                if (activo) {
                    setStep(0);
                    setCapaObligatoria(data);
                    setRespuestSecleccionada(preguntas.map(item => ({
                        idCapacitacion: data.id,
                        idPregunta: item.id,
                        idItem: item.numeroPregunta,
                        idRespuesta: null
                    })));
                }
            } catch (error) {
                if (activo) setErrorCarga(error.message || "No se pudo cargar la capacitación.");
            } finally {
                if (activo) setCargando(false);
            }
        };

        getCapacitacion();
        return () => { activo = false; };
    },[idCapacitacion, intentoCarga])
    const onChange = nextStep => {
        setStep(nextStep < 0 ? 0 : nextStep > numeroPreguntas -1 ? numeroPreguntas-1 : nextStep);
      };

        
    const onNext = () => onChange(step + 1);
    const onPrevious = () => onChange(step - 1);
    const goToListaObligatoria = () => navigate("../Capacitacion/Seccion/" + idSeccion + "/ListaObligatoria");
    const handleChange = (idPregunta, valor) => {
        setRespuestSecleccionada(previous => previous.map(item =>
            item.idPregunta === idPregunta
                ? { ...item, idRespuesta: valor }
                : item
        ));
    };
    const registrar = async ({jsonRespuestas})=>{
        let jwt = window.localStorage.getItem("jwt");
        try {
            const data = await RegistrarRespuestasUsuario({jsonRespuestas,jwt});
            setResultadoUsuario(data)
            if(data.estado ==="Exitoso")
            {
                setTituloDialog("¡Felicitaciones!")
                setEstadoRespuesta("Exitoso")
            }
            else{
                if(data.intentosPendientes > 0)
                {
                    setTituloDialog("¡No te desanimes!")
                    setEstadoRespuesta("Pendiente")

                }else{
                    setTituloDialog("¡Lo sentimos!")
                    setEstadoRespuesta("Perdido")

                }
            }
            setMostrarDialog(true)
        } catch (errors) {
            toast.current.show({severity:'error', summary: 'Error', detail:errors.message, life: 7000})
        } finally {
            setEnviando(false);
        }
    }

    const enviarRespuestas =()=>{
        if (enviando || numeroPreguntas === 0) return;

        const hayRespuestasFaltantes = respuestSecleccionada.some(x => x.idRespuesta === null || x.idRespuesta === undefined);
        if(hayRespuestasFaltantes)
        {
            toast.current.show({severity:'error', summary: 'Error', detail:"Existe preguntas que no han sido respondidas.", life: 7000})
            return;
        }

        let jsonRespuestas = JSON.stringify(respuestSecleccionada,null,2)
    setEnviando(true);
        registrar({jsonRespuestas})


    }
    const footerDialog=
            <div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"100%"}}>
                <Boton nombre={"Ir a pendientes"} color="primary" widths="184px" metodoClick={goToListaObligatoria}></Boton>
            </div>
    ;
    return ( 
        <div className="eva-detalleCapaObligatoria" style={{ marginLeft: 40 }}>
            <ToastEva ref={toast} position="top-center"></ToastEva>
             <div className="eva-dashboard-header">
                 <div className="header-agrupado">
                    <div>
                        <i href="#" onClick={() => navigate(-1)} className="p-eva-icon-atras">
                            <Iconsax.ArrowLeft color="#000000" />
                        </i>
                    </div>                                    
                </div>                
                <div>{capaObligatoria && <label htmlFor="header">{capaObligatoria.nombreCapacitacion}</label>}</div>
            </div>
            {cargando && <div className="eva-dashboard-preguntas" style={{marginTop:24}}>Cargando preguntas...</div>}
            {errorCarga && !cargando && <div className="eva-dashboard-preguntas" style={{marginTop:24}}>
                <div>{errorCarga}</div>
                <Boton nombre="Reintentar" color="primary" metodoClick={()=>setIntentoCarga(previous => previous + 1)} widths="184px"></Boton>
            </div>}
            {!cargando && !errorCarga && numeroPreguntas === 0 && <div className="eva-dashboard-preguntas" style={{marginTop:24}}>
                No hay preguntas disponibles para esta capacitación.
            </div>}
            {!cargando && !errorCarga && numeroPreguntas > 0 && <div className="eva-dashboard-preguntas" style={{marginTop:24}}>
                <div className="preguntas-steps">
                    <Steps current={step}>
                        {
                            preguntas.map((item,i)=>{
                                         return(<Steps.Item key={item.id || i} icon={i+1}/>)
                            })
                        }
                    </Steps>
                </div>
                <div className="preguntas-detalle">
                    <div className="preguntas-detalle-nombre titulo">
                        {step +1+". "}
                        {preguntaActual?.detallePregunta}
                    </div>
                    <div className="preguntas-detalle-alternativas">
                        <ListBox value={respuestaActual?.idRespuesta ?? null}
                            disabled={Boolean(visualizacion)}
                            onChange={(e)=>{
                                handleChange(preguntaActual.id, e.value)
                            }} 
                            options={preguntaActual?.capacitacion_obligatoria_alternativas || []}
                            optionLabel = "detalleAlternativa"
                            optionValue="id"
                        ></ListBox>
                    </div>
                </div>
                

                <div style={{display:"flex",justifyContent:"end"}}>
                    {step > 0 && <Boton nombre={"Regresar"} color="secondary" metodoClick={onPrevious} widths="184px"></Boton>} 
                    {step > -1 && step < numeroPreguntas -1 && <Boton nombre={"Continuar"} color="primary"  metodoClick={onNext} widths="184px"></Boton>}
                    {(step === numeroPreguntas-1 &&mostrarBotonEnviar) && <Boton nombre={"Enviar"} color="primary"  metodoClick={enviarRespuestas} disabled={enviando} loading={enviando} widths="184px"></Boton>}
                    {(step === numeroPreguntas-1 &&!mostrarBotonEnviar) && <Boton nombre={"Ir a capacitaciones Obligatorias"} color="primary"  metodoClick={goToListaObligatoria} widths="280px"></Boton>}

                </div>
               
            </div>}
            <Dialog visible={mostrarDialog} onHide={goToListaObligatoria}
                footer={footerDialog}  className ="p-eva-dialogRespuestas"                
                >
                
                <div className="confirmaRespuestas"><label >{tituloDialog}</label> </div>
                <div>
                    
                    {
                        estadoRespuesta === "Exitoso" && 
                        <label className="dialogRespuestas-mensaje">Aprobaste el test, respuestas respondidas correctamente <span className="respuestaCorrectas-exitoso">{resultadoUsuario.respuestasCorrectas}/{capaObligatoria.capacitacion_obligatoria_preguntas.length}</span>. A continuación puedes revisar si tienes alguna capacitación pendiente</label>
                    }
                    {
                        estadoRespuesta ==="Pendiente" &&
                        <label className="dialogRespuestas-mensaje">Puedes lograr mejores resultados, respuestas respondidas correctamente <span className="respuestaCorrectas-error">{resultadoUsuario.respuestasCorrectas}/{capaObligatoria.capacitacion_obligatoria_preguntas.length}</span>. 
                        {resultadoUsuario.intentosPendientes == 2 ? "Tienes dos intentos": "Tienes un intento" } más para poder enviar el test.</label>

                    }
                    {
                        estadoRespuesta ==="Perdido" && 
                        <label className="dialogRespuestas-mensaje">Desaprobaste los 3 intentos, respuestas respondidas correctamente <span className="respuestaCorrectas-error">{resultadoUsuario.respuestasCorrectas}/{capaObligatoria.capacitacion_obligatoria_preguntas.length}</span>. Te recomendamos ver a más detalle el video de la capacitación para los siguientes test.</label>

                    }
                </div>
                {/* <div className="peva-label">
                    
                </div> */}
            </Dialog>
        </div>
     );
}
 
export default PreguntasCapaObligatoria;